export const ANOTHER_CLIENT_CONTACTS_MODAL_NAME = 'contacts';

export const CONTACT_REQUESTS_COUNT_TO_SHOW_PAYMENT_MODAL = 2;
